let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("124I9"), load("95ven")]).then(() => parcelRequire('l0J6Z'));